import { render, staticRenderFns } from "./MemberTag.vue?vue&type=template&id=1a1ddbe4&scoped=true"
import script from "./MemberTag.vue?vue&type=script&lang=js"
export * from "./MemberTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1ddbe4",
  null
  
)

export default component.exports